/*
 * File: InputAutocomplete.js
 * Project: mp-mobile-app
 *
 * Copyright (c) 2019 MacPractice, Inc. All rights reserved.
 *
 * Description: Formatting for input element with autocomplete
 */
import React from "react";
import { observer } from "mobx-react";
import UIAutoComplete from "components/ui/UIAutoComplete";
import InputLabel from "@material-ui/core/InputLabel";
import { withStyles } from "@material-ui/core/styles";
import PropTypes from "prop-types";

const styles = theme => ({
  formLabel: {
    marginLeft: theme.spacing(1),
    marginTop: theme.spacing(-1.5),
    fontSize: theme.spacing(1.5)
  }
});

const InputAutocomplete = ({
  field,
  classes,
  value,
  error,
  parentOnBlur,
  autoCompleteOnChange
}) => {
  return (
    <React.Fragment>
      <InputLabel htmlFor={field.label} className={classes.formLabel}>
        {field.label}
      </InputLabel>

      <UIAutoComplete
        error={error}
        onChange={autoCompleteOnChange}
        onBlur={parentOnBlur}
        name={field.name}
        value={value}
        disabled={field.disabled}
        InputProps={field.materialInputProps}
        placeholder={field.placeholder}
        options={field.options}
      />
    </React.Fragment>
  );
};

InputAutocomplete.propTypes = {
  field: PropTypes.object.isRequired,
  classes: PropTypes.object.isRequired,
  value: PropTypes.string,
  error: PropTypes.bool,
  parentOnBlur: PropTypes.func,
  autoCompleteOnChange: PropTypes.func
};

export default withStyles(styles)(observer(InputAutocomplete));
